import type { ChatUsage } from '../engine/events'

/**
 * The fresher of this window's streamed totals and the fetched snapshot, which
 * may carry turns another window or device ran since. Without both timestamps
 * the live value wins: an undated snapshot is an old backend's, or an empty
 * record fetched before the first step landed.
 */
export function pickFreshestUsage(live: ChatUsage | undefined, fetched: ChatUsage | undefined): ChatUsage | undefined {
  if (!live || !fetched) {
    return live ?? fetched
  }
  if (live.updatedAt === null || fetched.updatedAt === null) {
    return live
  }
  return fetched.updatedAt > live.updatedAt ? fetched : live
}

/**
 * Whether fetching the chat's usage is worth a request: not for a temp id the
 * backend hasn't confirmed, and not while this window's stream is delivering
 * the totals.
 */
export function shouldFetchChatUsage(
  chatId: string | undefined,
  { localChatIds, isTurnLive }: { localChatIds: ReadonlySet<string>; isTurnLive: boolean },
): boolean {
  return !!chatId && !isTurnLive && !localChatIds.has(chatId)
}
